import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MenuMappingService {

  // Map sidebar routes to menu slugs
  private routeToSlugMap: { [key: string]: string } = {
    // Main sidebar routes
    '/statement': 'statement',
    '/group': 'group',
    '/voucher': 'voucher',
    '/ledger': 'ledger',
    '/voucher-posting': 'voucher-posting',
    '/voucher-posting-create': 'voucher-posting-create',
    '/audit-report': 'audit-report',
    '/day-book': 'day-book',
    '/ledger-book': 'ledger-book',
    '/statement-view': 'statement-view',
    '/branch': 'branch',
    '/category-master': 'category-master',
    '/category-item-mapping-master': 'item-master',
    '/gst-master': 'gst-master',
    '/service-master': 'service-master',
    '/create-invoice-payment-dialog': 'payment-receive',
    '/section-master': 'section-master',
    '/profit-cost-center': 'profit-cost-center',
    '/bulk-voucher-posting': 'bulk-voucher-posting',
    '/budget-master': 'budget-master',
    '/budget-view': 'budget-view',
    '/contact-person-master': 'contact-person-master',
    '/document': 'document',
    '/approval-path-master': 'approval-path-master',
    '/queue-box': 'queue-box',
    '/profit_cost_category_master': 'profit_cost_category_master',
    '/category_budget_master': 'category_budget_master',
    '/category_budget-view': 'category_budget-view',
    '/budget-ledger-view': 'budget-ledger-view',

    // Stocksphere routes (without /stocksphere prefix as they are child routes)
    'item_master': 'stocksphere-item-master',
    'store-master': 'stocksphere-store-master',
    'sku-master': 'stocksphere-sku-master',
    'inventory': 'stocksphere-inventory',

    // Supplysync routes (without /supplysync prefix as they are child routes)
    'vendor-master': 'supplysync-vendor-master',
    'vendor-branch-master': 'supplysync-vendor-branch-master',
    'voucher-posting-supplysync': 'supplysync-voucher-posting',
    'voucher-posting-create-supplysync': 'supplysync-voucher-posting-create',
    'customer-master': 'supplysync-customer-master',
    'customer-branch-master': 'supplysync-customer-branch-master',
    'contact-person-master': 'supplysync-contact-person-master',
    'requisition-master': 'supplysync-requisition-master',
    'request-for-quotation-master': 'supplysync-rfq-master',
    'quotation-receive': 'supplysync-quotation-receive',
    'quotation-comparision': 'supplysync-quotation-comparison',
    'purchase-order': 'supplysync-purchase-order',
    'grn-master': 'supplysync-grn-master',
    'quality-check': 'supplysync-quality-check',
    'sales-order': 'supplysync-sales-order',
    'gsn-master': 'supplysync-gsn-master',
    'invoice-details': 'supplysync-invoice-details',
    'purchase-order-view': 'supplysync-purchase-order-view',
    'requisition-report': 'supplysync-requisition-report',
    'purchase-order-manual': 'supplysync-purchase-order-manual',
    // 'company-unit-master': 'company-unit-master',
    // 'company-service-master': 'company-service-master',
    // 'company-item-master': 'company-item-master',
    '/fixed-assets-template': 'fixed-assets-template',
    '/company-act-category': 'company-act-category',
    '/it-act-category': 'it-act-category',
    '/depreciation-method': 'depreciation-method',
    '/fixed-assets-master': 'fixed-assets-master',
  };

  constructor() { }

  // Get menu slug for a given route
  getMenuSlug(route: string): string | null {
    console.log("route      slug",route)
    
    // Try direct lookup first
    let slug = this.routeToSlugMap[route];
    console.log("slug1",slug)
    if (slug) {
      return slug;
    }
    
    // Try with leading slash if route doesn't start with /
    if (!route.startsWith('/')) {
      slug = this.routeToSlugMap['/' + route];
      console.log("slug2",slug)
      if (slug) {
        return slug;
      }
    }
    
    // Try without leading slash if route starts with /
    if (route.startsWith('/')) {
      slug = this.routeToSlugMap[route.substring(1)];
      console.log("slug3",slug)
      if (slug) {
        return slug;
      }
    }
    
    return null;
  }

  // Check if a route has menu access
  hasMenuAccess(route: string, userMenus: any[]): boolean {
    const slug = this.getMenuSlug(route);
    if (!slug) {
      return true; // If no mapping exists, allow access
    }

    // Check if the slug exists in user menus (including nested children)
    return this.checkMenuAccess(slug, userMenus);
  }

  // Recursively check menu access including children
  private checkMenuAccess(slug: string, menus: any[]): boolean {
    for (const menu of menus) {
      if (menu.slug === slug) {
        return true;
      }
      if (menu.children && menu.children.length > 0) {
        if (this.checkMenuAccess(slug, menu.children)) {
          return true;
        }
      }
    }
    return false;
  }

  // Get all accessible routes for a user
  getAccessibleRoutes(routes: any[], userMenus: any[]): any[] {
    return routes.filter(route => this.hasMenuAccess(route.path, userMenus));
  }
}
